import { useState } from "react";
import { useSelector } from "react-redux";
import API from "services/axios";
import authHeader from "services/auth-header";

const formatPkt = (isoString) => {
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Karachi",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).format(new Date(isoString));
  } catch {
    return isoString;
  }
};

export default function WOApprovalAudit() {
  const userInfo = useSelector((state) => state.user?.userInfo);
  const [woIdInput, setWoIdInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  if (userInfo?.roles !== "admin") {
    return (
      <div className="p-4">
        <h4>Access Denied</h4>
        <p>This page requires an admin login.</p>
      </div>
    );
  }

  const handleLookup = async (e) => {
    e.preventDefault();
    const woId = Number(woIdInput);
    if (!woId) {
      setError("Enter a valid WO number.");
      return;
    }
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const { data } = await API.get(`/wo-lot-approval-history?woId=${woId}`, {
        headers: authHeader(),
      });
      if (data?.success) {
        setResult(data.data);
      } else {
        setError(data?.message || "Lookup failed.");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Lookup failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="p-4"
      style={{
        marginLeft: 260,
      }}
    >
      <h4>WO Approval History Audit</h4>
      <form
        onSubmit={handleLookup}
        className="d-flex gap-2 align-items-center mb-4"
      >
        <input
          type="number"
          className="form-control"
          style={{ maxWidth: 200 }}
          placeholder="WO number (e.g. 8541)"
          value={woIdInput}
          onChange={(e) => setWoIdInput(e.target.value)}
        />
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Looking up..." : "Look up"}
        </button>
      </form>

      {error && <div className="alert alert-danger">{error}</div>}

      {result && (
        <>
          <p>
            <strong>W-{result.woId}</strong> — {result.jobName} — current
            status: {result.currentApprovalStatus ? "Approved" : "Not approved"}
          </p>
          {result.log.length === 0 ? (
            <p>No history recorded yet for this order.</p>
          ) : (
            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Time (PKT)</th>
                  <th>Type</th>
                  <th>Action</th>
                  <th>Note</th>
                  <th>Actor</th>
                  <th>IP</th>
                  <th>Device</th>
                </tr>
              </thead>
              <tbody>
                {result.log.map((entry, i) => (
                  <tr key={i}>
                    <td>{formatPkt(entry.timestamp)}</td>
                    <td>{entry.type}</td>
                    <td>{entry.action}</td>
                    <td>{entry.note}</td>
                    <td>{entry.by}</td>
                    <td>{entry.ip || "—"}</td>
                    <td title={entry.userAgent || ""}>
                      {entry.userAgent
                        ? entry.userAgent.slice(0, 40) +
                          (entry.userAgent.length > 40 ? "..." : "")
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </div>
  );
}
